<template>
  <div class="hero">
    <div class="hero__overlay_dym">
      <div class="overlay-contents-wrapper">
        <div class="overlay-contents">
          <a href="https://tommyjohn.com/">
            <img
              class="tj-logo"
              alt="Tommy John Logo"
              src="../images/tj-logo_horizontal.svg"
            />
          </a>
          <span class="login-user-type" @click="changeLoginForm">Vendor Login</span>
          <span class="login-user-type hidden" @click="changeLoginForm">Member Login</span>
          <h2>Log in</h2>
          <div class="member-login login-user-type">
            <h4>
              Please select your User Type
            </h4>
            <div class="drop-down">
              <Dropdown
                v-model="selectedUserType"
                :options="userType"
                optionLabel="name"
                optionValue="code"
                placeholder="Select a User Type"
                @change="userTypeOptionChanged"
              />
            </div>

            <div class="user-options" v-if="displayNewUserSection">
              <div class="user-option-section">
                <h4>
                  Please select your Team
                </h4>
                <div class="drop-down">
                  <Dropdown
                    v-model="selectedTeam"
                    :options="teams"
                    optionLabel="team_name"
                    optionValue="team_code"
                    placeholder="Select a Team"
                    @change="userTeamChanged"
                  />
                </div>
              </div>

              <div class="user-option-section" v-if="isLiabilityTeamUser">
                <h4>
                  Please select Vendor Name
                </h4>
                <div class="drop-down">
                  <Dropdown
                    v-model="selectedVendor"
                    :options="vendorNames"
                    optionLabel="vendor_name"
                    optionValue="vendor_code"
                    placeholder="Select a Vendor Name"
                    @change="userVendorChanged"
                  />
                </div>
              </div>
            </div>
            <button class="button" @click="handleButtonClick" :disabled="isDisabled">Sign Up With Google</button>
          </div>
          <div class="vendor-login hidden login-user-type">
            <div class="tab_container">
              <input id="tab1" type="radio" name="tabs" checked class="tabInputs">
              <label for="tab1" class="tabLabel">Existing User</label>
              <input id="tab2" type="radio" name="tabs" class="tabInputs">
              <label for="tab2" class="tabLabel">New User</label>

              <section id="content1" class="tab-content">
                <div class="mainError error" ref="mainLoginError">Incorrect email or password</div>
                <form class="loginForm" @submit.prevent="validateLogin">
                  <p class="newUserInputs-container">
                    <InputText
                      placeholder="Email"
                      type="email"
                      name="email"
                      class="newUserInputs"
                      v-model="email"
                    />
                    <span class="form-error error" ref="emptyLoginEmail">Please enter valid email</span>
                  </p>
                  <p class="newUserInputs-container">
                    <InputText
                      placeholder="Password"
                      type="password"
                      name="pass"
                      class="newUserInputs"
                      v-model="password"
                    />
                    <span class="form-error error" ref="emptyLoginPass">Please enter a Password</span>
                  </p>
                  <button class="button vendorLoginBtn" type="submit">Login</button>
                </form>
                <!-- <p class="text-center forgotPassContainer"><span class="forgotPass">Forgot Password?</span></p> -->
              </section>

              <section id="content2" class="tab-content">
                <form class="signupForm" @submit.prevent="validateSignup">
                  <div class="mainError error" ref="mainSignupError">Email is already taken!</div>
                  <!-- <div class="mainSuccess" ref="mainSignupSuccess">Signed in</div> -->
                  <p class="newUserInputs-container">
                    <InputText
                      placeholder="Username"
                      name="name"
                      v-model="username"
                      class="newUserInputs"
                    />
                    <span class="form-error error" ref="emptySignupUsername">Please enter a valid name</span>
                  </p>
                  <p class="newUserInputs-container">
                    <InputText
                      placeholder="Vendor Name"
                      name="name"
                      v-model="name"
                      class="newUserInputs"
                    />
                    <span class="form-error error" ref="emptySignupName">Please enter a valid name</span>
                  </p>
                  <p class="newUserInputs-container">
                    <InputText
                      placeholder="Email"
                      type="email"
                      name="email"
                      v-model="signupEmail"
                      class="newUserInputs"
                    />
                    <span class="form-error error" ref="emptySignupEmail">Please enter valid email</span>
                  </p>
                  <p class="newUserInputs-container">
                    <InputText
                      placeholder="Password"
                      type="password"
                      v-model="signupPassword"
                      minlength="6"
                      name="pass"
                      class="newUserInputs"
                    />
                    <span class="form-error error" ref="emptySignupPass">Please enter valid password</span>
                  </p>
                  <p class="newUserInputs-container">
                    <InputText
                      placeholder="Confirm Password"
                      type="password"
                      name="confirmPass"
                      minlength="6"
                      v-model="confirmPass"
                      class="newUserInputs"
                    />
                    <span class="form-error error" ref="emptySignupConfPass">Please enter valid password</span>
                    <span class="form-error error" ref="passDontMatch">Password dont match</span>
                  </p>
                  <button class="button vendorLoginBtn" type="submit">Signup</button>
                </form>
              </section>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import http from "../../http-common";
import swal from "sweetalert";
import InputText from "primevue/inputtext";
import NewUser from "./new-user"

var auth2; // The Sign-In object.

/* eslint-disable */
export default {
  name: "login",
  data() {
    return {
      user: "",
      signupEmail: "",
      email: "",
      password: "",
      name: "",
      confirmPass: "",
      signupPassword: "",
      emptyLoginEmail: "",
      emptyLoginPass: "",
      mainLoginError: "",
      username: "",
      isLoaded: false,
      selectedUserType: null,
      selectedVendor: null,
      selectedTeam: null,
      displayNewUserSection: false,
      isLiabilityTeamUser: false,
      isDisabled: true,
      vendorNames: [],
      vendorDetails: [],
      userType: [
        { name: "New User", code: "New User" },
        { name: "Existing User", code: "Existing User" }
      ],
      teams: [],
      apiUrlPath: 'api/users',
    };
  },
  components: {
    Dropdown,
    InputText,
  },
  methods: {
    checkButtonStatus () {
      if(this.selectedUserType && this.selectedVendor && this.selectedTeam) {
        this.isDisabled = false;
      } else if (this.selectedUserType == "Existing User") {
        this.isDisabled = false;
      } else if (this.selectedUserType == "New User" && this.selectedTeam && this.isLiabilityTeamUser == false) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    retrieveUsers () {
      let userInfo = {};
      let userType = "";
      userInfo.user_email = gapi.auth2
        .getAuthInstance()
        .currentUser.get()
        .getBasicProfile()
        .getEmail();
      userInfo.username = gapi.auth2
        .getAuthInstance()
        .currentUser.get()
        .getBasicProfile()
        .getName();

        userInfo.team = this.selectedTeam;
        userInfo.vendor_name = this.selectedVendor;

      if (this.selectedTeam != null) {
        userInfo.team = this.selectedTeam.name;
      } else {
        userInfo.team = "";
      }
      userInfo = JSON.stringify(userInfo);

      http
        .get(`${this.apiUrlPath}/${userInfo}`)
        .then((response) => {
          if (response.data.length && response.data[0].status == "Active") {
            this.user = response.data[0];
            userType = "Existing User";

            if (this.user.role == "Admin") {
              this.$router.push({ name: "ApproveUsers" });
            } else if (this.user.team != "OPs Team" && this.user.team != "CX Team") {
              this.$router.push({ name: "MasterLiabilityChart" });
            } else {
              this.$router.push({ name: "backorderCustList" });
            }
          } else {
            userType = "New User";
            this.user = response.data;
            this.$router.push({ name: "NewUser" });
          }
          sessionStorage.setItem("User Information", JSON.stringify(this.user));
        })
        .catch((e) => {
          console.log(e);
        });
      return userType;
    },
    userTypeOptionChanged() {
      if (this.selectedUserType == "New User") {
        this.displayNewUserSection = true;
      } else {
        this.displayNewUserSection = false;
      }
      this.checkButtonStatus ();
    },
    userTeamChanged () {
      if (this.selectedTeam == "Factory Team") {
        this.isLiabilityTeamUser = true
      } else {
        this.isLiabilityTeamUser = false
      }
      this.checkButtonStatus ();
      // console.log("selectedTeam:",this.selectedTeam);
    },
    userVendorChanged () {
      // if (this.selectedTeam != "OPs Team" && this.selectedTeam != "CX Team") {
      //   this.isLiabilityTeamUser = true
      // } else {
      //   this.isLiabilityTeamUser = false
      // }
      this.checkButtonStatus ();
      // console.log("selectedTeam:",this.selectedTeam);
    },
    changeLoginForm () {
      let element = document.getElementsByClassName("login-user-type");
      for (var i = 0; i < element.length; i++) {
        element[i].classList.toggle("hidden");
      }
    },
    validateLogin () {
      this.$refs.emptyLoginEmail.style.display = "none";
      this.$refs.emptyLoginPass.style.display = "none";
      this.$refs.mainLoginError.style.display = "none";
      if(this.email === "" || !this.email) {
        this.$refs.emptyLoginEmail.style.display = "block";
      } 
      if( this.password === "" || !this.password) {
        this.$refs.emptyLoginPass.style.display = "block";
      }

      this.vendorDetails = {
        vendor_email: this.email,
        vendor_password: this.password,
      }

      let vendorInfo = JSON.stringify(this.vendorDetails);

      if(this.$refs.emptyLoginEmail.style.display === "none" && this.$refs.emptyLoginPass.style.display === "none") {
        http
        .get(`${this.apiUrlPath}/vendor-login/${vendorInfo}`)
        .then((response) => {
          if (response.status == 200) {
            if(response.data[0].status === 'Active') {
              this.$router.push({ name: "MasterLiabilityChart" });
            } else {
              this.$router.push({ name: "NewUser" });
            }
            sessionStorage.setItem("User Information", JSON.stringify(response.data[0]));
          }
        })
        .catch(() => {
          this.$refs.mainLoginError.style.display = "block";
        });
      } else {
        return false;
      }
    },
    validateSignup () {
      this.$refs.emptySignupName.style.display = "none";
      this.$refs.emptySignupUsername.style.display = "none";
      this.$refs.emptySignupEmail.style.display = "none";
      this.$refs.emptySignupPass.style.display = "none";
      this.$refs.emptySignupConfPass.style.display = "none";
      this.$refs.mainSignupError.style.display = "none";
      this.$refs.passDontMatch.style.display = "none";

      if(this.signupEmail === "" || !this.signupEmail) {
        this.$refs.emptySignupEmail.style.display = "block";
      } 
      if( this.name === "" || !this.name) {
        this.$refs.emptySignupName.style.display = "block";
      }
      if(this.username === "" || !this.username) {
        this.$refs.emptySignupUsername.style.display = "block";
      }
      if(this.confirmPass === "" || !this.confirmPass) {
        this.$refs.emptySignupConfPass.style.display = "block";
      } 
      if(this.signupPassword === "" || !this.signupPassword) {
        this.$refs.emptySignupPass.style.display = "block";
      }

      if(this.signupPassword !== this.confirmPass) {
        this.$refs.passDontMatch.style.display = "block";
      }

      if (
        this.$refs.emptySignupName.style.display === "none" && this.$refs.emptySignupEmail.style.display === "none" &&
        this.$refs.emptySignupPass.style.display === "none" && this.$refs.emptySignupConfPass.style.display === "none" &&
        this.$refs.passDontMatch.style.display === "none" && this.$refs.emptySignupUsername.style.display === "none"
      ) {

        this.vendorDetails = {
          vendor_username: this.username,
          vendor_name: this.name,
          vendor_email: this.signupEmail,
          vendor_password: this.signupPassword,
        };

        http
        .post(`${this.apiUrlPath}/vendor-login`, this.vendorDetails)
        .then((response) => {
          if (response.status == 200) {
            this.$router.push({ name: "NewUser" });
          }
        })
        .catch((err) => {
          this.$refs.mainSignupError.style.display = "block";
        });
      } else {
        return false;
      }
    },
    initGoogleSignup() {
      let signIn = this.onSignInSuccess;
      auth2 = window.gapi.auth2
        .init({
          client_id: process.env.VUE_APP_CLIENTID,
          scope: "profile",
        })
        .then(function () {
          window.gapi.auth2
            .getAuthInstance()
            .signIn()
            .then(() => {
              signIn();
            })
            .catch((e) => {
              console.log(e);
            });
        });
    },
    onSignInSuccess() {
      this.retrieveUsers();
    },
    handleButtonClick() {
      window.gapi.load("auth2", this.initGoogleSignup);
    },
  },
  mounted() {
    if (
      window.gapi &&
      window.gapi.auth2 &&
      window.gapi.auth2.getAuthInstance().isSignedIn.get()
    ) {
      window.gapi.auth2.getAuthInstance().signOut();
    }

    http
    .get(`${this.apiUrlPath}/all-users-team`)
        .then((response) => {
          this.teams = response.data;
        })
        .catch((e) => {
          console.log(e);
        });

        http
    .get(`${this.apiUrlPath}/all-vendors`)
        .then((response) => {
          this.vendorNames = response.data;
          console.log(response.data);
          this.isLoaded = true;
        })
        .catch((e) => {
          console.log(e);
        });
  },

};
</script>

<style>
img {
  width: 100%;
}
.tj-logo {
  width: 50%;
}
.error {
  color: #9b2e29;
  margin-top: 4px;
  display: none;
}
.mainError {
  border: 1px solid #9b2e29;
  padding: 16px;
  margin-bottom: 16px;
}
.forgotPassContainer {
  margin-bottom: 0;
}
.hidden {
  display: none
}
.mainSuccess {
  color: #00424a;
  border: 1px solid #00424a;
  padding: 16px;
}
.text-center {
  text-align: center;
}

.forgotPass {
  cursor: pointer;
  text-decoration: underline;
  color: #00424a;
}

span.login-user-type {
  float: right;
  color: #00424a;
  position: relative;
  top: 16px;
  text-decoration: underline;
  cursor: pointer;
}

.tab_container {
	margin: 0 auto;
	position: relative;
  border: 1px solid #00424a;
  margin-top: 24px;
}

.tabInputs, .tab-content {
  clear: both;
  padding-top: 10px;
  display: none;
}

.tabLabel {
  font-size: 18px;
  display: block;
  float: left;
  width: 50%;
  text-align: center;
  border: 1px solid #00424a;
  position: relative;
  bottom: 1px;
  padding: 16px;
}

#tab1:checked ~ #content1,
#tab2:checked ~ #content2 {
  display: block;
  padding: 20px;
  background: #fff;
  color: #333;
}
.tab_container [id^="tab"]:checked + .tabLabel {
  background: #fff;
  position: static;
  border: none;
}

/*Media query*/
@media only screen and (max-width: 900px) {
  .tab_container {
    width: 98%;
  }
}

input.newUserInputs {
  width: 100%;
  padding: 14px 10px;
  font-size: 16px;
}

.button.vendorLoginBtn {
  margin-top: 0;
}
.newUserInputs-container {
  margin: 0 0 14px;
}

.overlay-contents h2 {
  margin-bottom: 4px;
  font-weight: 400;
  color: #00424a;
}

.drop-down .p-inputwrapper {
  width: 75%;
}

.drop-down .p-inputtext {
  padding: 14px 10px;
  font-size: 16px;
}

.overlay-contents h3,
.overlay-contents h4 {
  margin: 14px 0;
  font-weight: 200;
  color: #4d4d4d;
}
.overlay-contents h2,
.overlay-contents h3,
.overlay-contents h4 {
  font-family: "Arial";
}
.hero {
  position: relative;
  background-image: url(../images/D_Hero.jpeg);
  height: 100vh;
  background-size: cover;
}

.hero__overlay_dym {
  position: absolute;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
}

@media only screen and (max-width: 767px) {
  .overlay-contents-wrapper {
    width: 95%;
    box-sizing: border-box;
    background: white;
    border-radius: 8px;
    padding: 1rem;
  }
}

@media only screen and (max-width: 480px) {
  .overlay-contents-wrapper {
    margin: 0 2%;
  }
}

@media only screen and (min-width: 768px) {
  .hero {
    background-image: url(../images/D_Hero.jpeg);
  }

  .overlay-contents-wrapper {
    max-width: 46.8rem;
    width: 95%;
    box-sizing: border-box;
    background: white;
    border-radius: 8px;
    padding: 2rem;
    width: 468px;
    margin-left: 20%;
  }
}
.button {
  padding: 15px 25px 15px;
  width: 100%;
  color: #fff;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0;
  display: inline-block;
  text-align: center;
  text-transform: capitalize;
  margin-top: 1rem;
  font-family: sans-serif;
  border-radius: 4px;
  border: 1px solid;
  background-color: #9b2e29;
  transition: all 0.3s ease 0s;
  text-decoration: none;
  cursor: pointer;
}

.button:disabled {
  background-color: #333;
}

.hero {
  width: 100%;
}
</style>
